<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div id="ContractsList">
    <actions :disableview="true"></actions>

    <page-loader v-if="loading"></page-loader>

    <div v-if="!loading" class="giga-contracts_wrap">
      <div class="accordion" role="tablist">
        <template v-for="contract in getContracts.elements">
          <div
            v-if="contract.attachments.length"
            :key="contract.id"
            class="giga-accordion_row"
          >
            <!-- {{contract}} -->
            <div class="accordion-row_header" header-tag="header" role="tab">
              <b-button block v-b-toggle="'acc' + contract.id">
                <i class="accordion-row_icon">
                  <svg
                    width="9"
                    height="6"
                    viewBox="0 0 9 6"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.24537e-08 5.4C2.30796e-08 5.736 0.2475 6 0.5625 6L8.4375 6C8.7525 6 9 5.736 9 5.4C9 5.244 8.94375 5.112 8.85375 5.004C8.76375 4.896 4.91625 0.204 4.91625 0.204C4.815 0.0839997 4.66875 -3.7865e-07 4.5 -3.93402e-07C4.33125 -4.08155e-07 4.185 0.0839997 4.08375 0.204L0.14625 5.004C0.0562497 5.112 6.60916e-08 5.244 5.24537e-08 5.4Z"
                      fill="#132D48"
                    />
                  </svg>
                </i>

                <div class="accordion-row-cols">
                  <div class="accordion-row-col accordion-col_name">
                    <label
                      >Contrat du
                      {{
                        moment(contract.signatureDate, "x").format("DD/MM/YYYY")
                      }}</label
                    >
                  </div>
                  <div class="accordion-row-col accordion-col_date">
                    Date de la signature
                  </div>
                  <div class="accordion-row-col accordion-col_action"></div>
                </div>
              </b-button>
            </div>
            <b-collapse
              class="accordion-tabpanel"
              :id="'acc' + contract.id"
              accordion="acces-row"
              role="tabpanel"
              visible
            >
              <ul class="accordion-items_list">
                <li
                  v-for="attachment in contract.attachments"
                  :key="[contract.id][attachment.id]"
                  class="
                  accordion-item
                  accordion-multi_choices accordion-multi_choices
                "
                >
                  <div class="contract-item">
                    <div class="accordion-row-col accordion-col_name">
                      <i class="file-extention">
                        <img
                          v-if="getFileExtention(attachment.name) == 'pdf'"
                          src="~@/assets/images/extensions/pdf.svg"
                        />
                        <img
                          v-if="getFileExtention(attachment.name) == 'docx'"
                          src="~@/assets/images/extensions/doc.svg"
                        />
                      </i>
                      <span>{{ attachment.name }}</span>
                    </div>
                    <div class="accordion-row-col accordion-col_date">
                      {{
                        moment(contract.signatureDate, "x").format("DD/MM/YYYY")
                      }}
                    </div>
                    <div class="accordion-row-col accordion-col_action">
                      <div class="giga-button">
                        <b-button
                          @click="download(attachment)"
                          class="giga-blue_button"
                        >
                          <b-spinner
                            variant="light"
                            small
                            class="align-middle"
                            v-if="
                              downloadLoader.loading === true &&
                                downloadLoader.ids.includes(attachment.id)
                            "
                          >
                          </b-spinner>
                          <svg
                            v-else
                            width="20"
                            height="17"
                            viewBox="0 0 20 17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            class="stroke"
                          >
                            <path
                              d="M18.2386 10.7527V14.0036C18.2386 14.8999 17.3821 15.6267 16.3258 15.6267H2.91284C1.85648 15.6267 0.999969 14.8999 0.999969 14.0036V10.7527"
                              stroke="white"
                              stroke-width="1.69271"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></path>
                            <path
                              d="M4.83139 6.68774L9.61642 10.7526L14.4072 6.68774"
                              stroke="white"
                              stroke-width="1.69271"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></path>
                            <path
                              d="M9.61639 10.7528V1"
                              stroke="white"
                              stroke-width="1.69271"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></path>
                          </svg>
                        </b-button>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </b-collapse>
          </div>
        </template>
      </div>

      <pagination
        v-if="getContracts.elements.length"
        :length="length"
        :rows="rows"
        :perPage="perPage"
        :currentPage="currentPage"
        v-on:changePerPage="changePerPage($event)"
        v-on:changeCurrentPage="changeCurrentPage($event)"
      ></pagination>
    </div>

    <!-- EMPTY STATE -->
    <div v-if="!getContracts.elements.length">
      <empty-state
        v-if="!getContracts.elements.length"
        module="simulations"
        title="Aucun élément trouvé pour l’instant!"
        description="Cette liste ne contient aucun élément."
        :addSimulation="false"
      ></empty-state>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Actions from "../../components/static/Actions.vue";
import Pagination from "../../components/static/Pagination.vue";
import PageLoader from "../../components/static/pageLoader.vue";
import { contractService } from "./services";
import moment from "moment";
import { documentService } from "@/views/service/document.service";
import EmptyState from "@/components/static/emptyState.vue";

export default {
  name: "Contracts",
  components: { EmptyState, Actions, Pagination, PageLoader },
  data() {
    return {
      scrollBarSettings: {
        scrollXMarginOffset: 50
      },
      perPage: 10,
      currentPage: 1,
      length: [10, 25, 50],
      sortBy: "id",
      sortDir: true,
      rowOpened: [],
      downloadLoader: {
        loading: false,
        ids: []
      },
      moment
    };
  },
  methods: {
    ...mapActions("contract", ["getContractsAction"]),

    getFileExtention(filename) {
      return filename.split(".").pop();
    },
    //
    // getDocExtention(docname) {
    //   let split = docname.split('.');
    //   let filename = split[0];
    //   let extension = split[1];
    //   if(filename.length > 10){
    //     docname = filename.substring(0, 15);
    //   }
    //   return docname+'...'+extension;
    // },
    // rowToggle(id) {
    //   const index = this.rowOpened.indexOf(id);
    //   if (index > -1) {
    //     this.rowOpened.splice(index, 1);
    //   } else {
    //     this.rowOpened.push(id);
    //   }
    // },
    changePerPage(perPage) {
      this.currentPage = 1;
      this.perPage = perPage;
      this.getContractsAction({
        currentPage: this.currentPage,
        perPage: this.perPage,
        sortBy: this.sortBy,
        sortDir: this.sortDir
      });
    },
    changeCurrentPage(currentPage) {
      this.currentPage = currentPage;
      this.getContractsAction({
        currentPage: this.currentPage,
        perPage: this.perPage,
        sortBy: this.sortBy,
        sortDir: this.sortDir
      });
    },
    download(attachment) {
      this.downloadLoader.loading = true;
      this.downloadLoader.ids.push(attachment.id);
      documentService.downloadDocument(attachment.id).finally(() => {
        this.downloadLoader.ids = this.downloadLoader.ids.filter(
          id => id !== attachment.id
        );
        console.log(this.downloadLoader);
      });
    }
  },
  computed: {
    ...mapGetters("contract", ["getContracts"]),
    ...mapGetters("loader", { loading: "getLoading" }),
    rows() {
      return this.getContracts.totalElements;
    }
  },
  mounted() {
    this.getContractsAction({
      currentPage: this.currentPage,
      perPage: this.perPage,
      sortBy: this.sortBy,
      sortDir: this.sortDir
    });
  }
};
</script>

<style scoped>
.view-area-table {
  position: relative;
  min-height: 350px;
  height: calc(100vh - 300px);
}

.btn-with-radius {
  border-radius: 10px;
}
</style>
